export const initDevTools = () => {
  window.VCDevTools = () => import( /* webpackChunkName: "vc-dev-tools" */'./dev-tools').then(({
    startVCDevTools
  }) => startVCDevTools === null || startVCDevTools === void 0 ? void 0 : startVCDevTools());
};